import { Route, Redirect } from 'react-router-dom';
import { account } from 'routes.js';

const protectedPaths = account.map((route) => route.layout + route.path);

const PrivateRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = localStorage.getItem('auth'); 

  return (
    <Route
      {...rest}
      render={(props) =>
        protectedPaths.some((path) => props.location.pathname.startsWith(path)) && !isAuthenticated ? (
          <Redirect to="/" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PrivateRoute;
